import BasePage from './BasePage'

function App() {

  return (
    <BasePage>
    Whoops! Page not found!
    </BasePage>
  )
}

export default App